import React, { createContext, useContext, useEffect, useMemo, useState, } from 'react';
import useVisibility from '../hooks/useVisibility';
import { browserSupportsNativeLazyLoading } from '../Image';
import Skeleton from '../Skeleton';
export var LazyContext = createContext(false);
// Hook for Components - u can use the wishlist by including this
export var useLazyLoad = function () { return useContext(LazyContext); };
// Provider - Wrap this to use useWishList
export var LazyProvider = function (_a) {
    var children = _a.children, onLoad = _a.onLoad, _b = _a.ignoreIfNativeIsSupported, ignoreIfNativeIsSupported = _b === void 0 ? false : _b;
    var _c = useState(ignoreIfNativeIsSupported && browserSupportsNativeLazyLoading()), isLoaded = _c[0], setIsLoaded = _c[1];
    // Event for outside
    useEffect(function () {
        if (isLoaded && onLoad)
            onLoad();
    }, [isLoaded]);
    return (React.createElement(LazyContext.Provider, { value: isLoaded }, isLoaded ? (React.createElement("div", null, children)) : (React.createElement(LazyListener, { onLoad: function () { return setIsLoaded(true); } }, children))));
};
var LazyListener = function (_a) {
    var children = _a.children, onLoad = _a.onLoad;
    var _b = useVisibility(), ref = _b[0], isVisible = _b[1];
    useMemo(function () { return isVisible && onLoad(); }, [isVisible]);
    return React.createElement("div", { ref: ref }, children);
};
// LazyLoading children
export var LazyConsumer = function (_a) {
    var children = _a.children, _b = _a.lazyContent, lazyContent = _b === void 0 ? function () { return React.createElement(Skeleton, { height: "1rem" }); } : _b;
    var isLoaded = useLazyLoad();
    return isLoaded ? React.createElement(React.Fragment, null, children) : lazyContent();
};
//# sourceMappingURL=index.js.map